import { render } from "./postsContainer.vue?vue&type=template&id=72ed2bb4&scoped=true"
import script from "./postsContainer.vue?vue&type=script&lang=js"
export * from "./postsContainer.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=72ed2bb4&lang=scss&scoped=true"

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ed2bb4"]])

export default __exports__